import { render, staticRenderFns } from "./oeStatistics.vue?vue&type=template&id=1c04b3b6&scoped=true"
import script from "./oeStatistics.vue?vue&type=script&lang=js"
export * from "./oeStatistics.vue?vue&type=script&lang=js"
import style0 from "./oeStatistics.vue?vue&type=style&index=0&id=1c04b3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c04b3b6",
  null
  
)

export default component.exports